import { render, staticRenderFns } from "./Tabular.vue?vue&type=template&id=00484862&"
import script from "./Tabular.vue?vue&type=script&lang=js&"
export * from "./Tabular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports